import { useState } from 'react';
import { appContent } from '@/mocks/home';

export default function AppSection() {
  const [qrError, setQrError] = useState(false);

  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14 max-w-[1000px] mx-auto">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">
              {appContent.title}
            </h2>
            <p className="text-sm text-foreground-500 mb-4">{appContent.subtitle}</p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-5">
              {appContent.description}
            </p>
            <ul className="space-y-2">
              {appContent.features.map((f, i) => (
                <li key={i} className="flex items-center gap-2 text-sm text-foreground-600">
                  <i className="ri-check-line text-primary-500 text-base"></i>
                  <span>{f}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="shrink-0">
            <div className="w-48 h-48 md:w-56 md:h-56 rounded-2xl bg-background-100 border-2 border-background-200 p-4 flex items-center justify-center">
              {!qrError ? (
                <img
                  src={appContent.qrImage}
                  alt="51吃瓜黑料网 移动端访问二维码"
                  className="w-full h-full object-contain rounded-lg"
                  onError={() => setQrError(true)}
                />
              ) : (
                <div className="flex flex-col items-center gap-2 text-foreground-400">
                  <i className="ri-qr-code-line text-4xl"></i>
                  <span className="text-xs">扫码访问</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}